import React, { useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { LabelledText, WhitePanelWithHeader } from "../../../../../ui";
import { ButtonPrimary } from "../../../../../Components/Button";
import { isRolePlatformAdmin, token } from "../../../../../modules/auth";
import { createCompany } from "../../../../../redux/actions";
import * as ROUTES from "../../../../../Router/rfp_routes";
import EnquiryCompanyReassignModal from "../../../../../Components/corporate/EnquiryCompanyReassignModal";
import NewCompanyAndClientModal from "../../../../../Components/corporate/NewCompanyAndClientModal";
const ContactCard = ({
  enquiryId,
  venueContact,
  companyDetails,
  companyBranch,
  clientDetails,
  isAgency,
  token,
  isRolePlatformAdmin,
  agency,
 anonContact
}) => {
  const [newCompanyModal, setNewCompanyModal] = useState(false);
  const [dontSaveDetailsModal, setDontSaveDetailsModal] = useState(false);
  const [company, setCompany] = useState(null);
  const [client, setClient] = useState(null);
  const [reassignCompanyModal, setReassignCompanyModal] = useState(false);

  const reassignCompany = (companyId, clientId) => {
    const formData = new FormData();
    formData.append("_method", "patch");
    formData.append("company_id", companyId);
    formData.append("client_id", clientId);

    return axios
      .post(
        window.API + ROUTES.API.REASSIGN_COMPANY.replace(":id", enquiryId),
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(() => window.location.reload());
  };

  const changeCompany = (request) => {
    if (company && client) {
      reassignCompany(company.id, client.id);
    }
  };

  const reassignCompanyAndClient = ({ company, user,anonymous_contact }) => {
      reassignCompany(company.id, user.id);
  };

  return (
    <div>
      {/*<WhitePanelWithHeader title="Venue Contact" icon="far fa-user">*/}
      {/*    <LabelledText label="Email" text='info@XXXXXXXX.com'/>*/}
      {/*    <LabelledText label="Phone" text='01733XXXXXX'/>*/}
      {/*</WhitePanelWithHeader>*/}

      {venueContact ? (
        <WhitePanelWithHeader title="Venue Contact for RFP" icon="far fa-user">
          {venueContact.name ? (
            <LabelledText label="Name" text={venueContact.name} styles={null} />
          ) : (
            <LabelledText label="Name" text={"Not provided"} styles={null} />
          )}

          <LabelledText
            label="Email"
            text={venueContact.email}
            styles={{
              overflowX: "clip",
              textOverflow: "ellipsis",
            }}
          />
          {venueContact.phone ? (
            <LabelledText
              label="Phone"
              text={venueContact.phone}
              styles={{
                overflowX: "clip",
                textOverflow: "ellipsis",
              }}
            />
          ) : (
            <LabelledText label="Phone" text={"Not provided"} styles={null} />
          )}
          {venueContact.mobile ? (
            <LabelledText
              label="Mobile"
              text={venueContact.mobile}
              styles={null}
            />
          ) : (
            <LabelledText label="Mobile" text={"Not provided"} styles={null} />
          )}
        </WhitePanelWithHeader>
      ) : (
        <WhitePanelWithHeader title="Venue Contact for RFP" icon="far fa-user">
          No Contact found for Venue
        </WhitePanelWithHeader>
      )}
      {anonContact ? (
        <WhitePanelWithHeader title="Contract Information" icon="far fa-user">
          {isAgency || isRolePlatformAdmin ? (
            <div className="mb-2">
              <div>
                <LabelledText
                  label="Company Name"
                  text={
                    anonContact.company_name
                  }
                />
                <LabelledText
                  label="Client Name"
                  text={
                    anonContact.client_name
                  }
                />
                <LabelledText
                  label="Email"
                  text={
                    anonContact.email
                  }
                />
                <LabelledText
                  label="Address"
                  text={
                    anonContact.billing_address
                  }
                />
              </div> </div>) : null}
        </WhitePanelWithHeader>) : null}
      <WhitePanelWithHeader title="Client Contact" icon="far fa-user">
        {isAgency || isRolePlatformAdmin ? (
          <div className="mb-2">
            {companyDetails?.is_dummy_company && !anonContact ? (
              <>

                <div className="text-sm bg-light-blue-grey px-3 py-3 my-3">
                  You can choose to save the company details in EDGE - this RFP will be assigned, and statistics and exports will reference the company and client. If not, simply add the details for one-off use in this Confirmation export.
                </div>
                <div className="text-sm bg-warning px-3 py-3 font-bold mb-3 text-white">
                  You have booked this event using your Agency as the client, to confirm and enable meaningful reporting, please choose one of the following options, otherwise agency details will be used.
                </div>

                {agency.company_count === 1 || (agency.only_has_dummy_company && !anonContact) ? null : (
                  <ButtonPrimary
                    classes="px-2 w-full text-xs mb-2"
                    onClick={() => setReassignCompanyModal(true)}
                  >
                    Choose an existing client
                  </ButtonPrimary>
                )}

                {anonContact ?
                 null
                  :    <><ButtonPrimary
                  classes="px-2 w-full text-xs mb-2"
                  onClick={() => setNewCompanyModal(true)}
                >
                  Add your Client Details
                </ButtonPrimary>
                </>}

                {anonContact ?
                  null
                  :    <><ButtonPrimary
                    classes="px-2 w-full text-xs mb-3"
                    onClick={() => setDontSaveDetailsModal(true)}
                  >
                    Add one-off details
                  </ButtonPrimary>
                  </>}


              </>
            ) : isRolePlatformAdmin ? (
              <ButtonPrimary
                classes="px-2 w-full text-xs"
                onClick={() => setReassignCompanyModal(true)}
              >
                Reassign company
              </ButtonPrimary>
            ) : null}

          </div>
        ) : null}

        {companyDetails ? (
          <div>
            <LabelledText
              label="Company Name"
              text={
                companyDetails.name

              }
              styles={null}
            />
            {!companyDetails.is_dummy_company ?
            <LabelledText
              label="Company Name"
              text={
                clientDetails.name

              }
              styles={null}
            /> : null}
          </div>

        ) : clientDetails ? (
          <LabelledText
            label="Client Name"
            text={clientDetails.name}
            styles={null}
          />
        ) : (
          <LabelledText
            label="Company Name"
            text={"Not Provided"}
            styles={null}
          />
        )}
        {companyBranch ? (
          <LabelledText
            label="Company Branch"
            text={companyBranch}
            styles={null}
          />
        ) : null}
        {clientDetails.email ? (
          <LabelledText
            label="Email"
            text={clientDetails.email}
            styles={{
              overflowX: "clip",
              textOverflow: "ellipsis",
            }}
          />
        ) : (
          <LabelledText
            label="Email"
            text={"Not provided"}
            styles={{
              overflowX: "clip",
              textOverflow: "ellipsis",
            }}
          />
        )}
        {clientDetails.phone ? (
          <LabelledText
            label="Phone"
            text={clientDetails.phone}
            styles={null}
          />
        ) : (
          <LabelledText label="Phone" text={"Not provided"} styles={null} />
        )}

        {clientDetails.mobile ? (
          <LabelledText
            label="Mobile"
            text={clientDetails.mobile}
            styles={null}
          />
        ) : (
          <LabelledText label="Mobile" text={"Not provided"} styles={null} />
        )}
      </WhitePanelWithHeader>

      {reassignCompanyModal ? (
        <EnquiryCompanyReassignModal
          onClose={() => setReassignCompanyModal(false)}
          changeCompany={changeCompany}
          setCompany={setCompany}
          company={company}
          client={client}
          setClient={setClient}
          agencyId={companyDetails?.agency_id || null}
        />
      ) : null}

      {newCompanyModal && (
        <NewCompanyAndClientModal
          title={"Add Client Details"}
          onClose={() => setNewCompanyModal(false)}
          token={token}
          showSearch={true}
          showNonSaveSwitch={true}
          setCompany={setCompany}
          company={company}
          changeCompany={changeCompany}
          agencyId={companyDetails?.agency_id || null}
          onSuccessRequest={reassignCompanyAndClient}
          onAnonSuccessRequest={() => window.location.reload()}
          enquiryId={enquiryId}
          isOneOffDetails={false}
        />
      )}
      {dontSaveDetailsModal && (
        <NewCompanyAndClientModal
          title={"Add One Off Details"}
          onClose={() => setDontSaveDetailsModal(false)}
          token={token}
          showSearch={true}
          showNonSaveSwitch={true}
          setCompany={setCompany}
          company={company}
          changeCompany={changeCompany}
          agencyId={companyDetails?.agency_id || null}
          onSuccessRequest={reassignCompanyAndClient}
          onAnonSuccessRequest={() => window.location.reload()}
          enquiryId={enquiryId}
          isOneOffDetails={true}
        />
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...state,
    token: token(state),
    isRolePlatformAdmin: isRolePlatformAdmin(state),
    agency: state.auth.agency,
  };
};

const mapDispatchToProps = {
  createCompany,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactCard);
